<template>
  <div :class="['wp-100 tl px-40', windowWidth > TABLET ? 'pb-80' : 'pb-40']">
    <slot></slot>
  </div>

</template>

<script setup>
  import {computed} from 'vue'
  import {TABLET} from '~/constant/common'
  import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

  const generalStore = useGeneralInfoStore()

  const windowWidth = computed(() => generalStore.generalData.windowWidth)

</script>

<style scoped lang="scss">

</style>
